export default __webpack_public_path__ + "static/media/CustomerEngagement.2b47596d.svg";